import { useState } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import Cookies from 'universal-cookie';
import { upperFirst } from 'lodash';
import OutsideClickHandler from 'react-outside-click-handler';

import peopleImage from 'Asset/image/people.svg';
import { TextBold, TextRegular } from 'UiKit/typography';
import { Condition, Iteration } from 'Component/others';
import SkeletonHeader from 'Component/skeleton/header';
import Notification from 'Component/notification';
import { useAppSystem } from 'Store/app';

import useLogout from 'Domain/logout/usePostLogout';
import { dropdownItems } from './const';

import styles from './styles.module.css';

const Header = () => {
  const cookie = new Cookies();
  const { isLoadingPage } = useAppSystem();
  const username = cookie.get('username');
  const organization = cookie.get('organization');

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { mutate: logout } = useLogout();

  return (
    <Flex className={styles['header__container']}>
      <Flex className={styles['header__section--left']} />

      <Flex className={styles['header__section--right']}>
        <Condition statement={!isLoadingPage} fallback={<SkeletonHeader />}>
          <Notification mr="4px" />
          <Flex className={styles['user-info__container']} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <Box className={styles['short-char__container']}>
              <Image src={peopleImage} alt="people" />
            </Box>

            <Box className={styles['user-organization__container']}>
              <TextBold className={styles['name__text']}>{upperFirst(username)}</TextBold>
              <Flex gap="2px">
                <TextRegular className={styles['organization__text']}>{upperFirst(organization?.name)}</TextRegular>
                <TextRegular className={styles['organization__text']}>{` - ${upperFirst(organization?.type)}`}</TextRegular>
              </Flex>
            </Box>
          </Flex>
        </Condition>
        <OutsideClickHandler onOutsideClick={() => setIsDropdownOpen(false)}>
          <Condition statement={isDropdownOpen}>
            <Flex className={styles['dropdown__container']} onClick={logout}>
              <Iteration
                items={dropdownItems}
                render={(item) => (
                  <Box className={styles['dropdown__item']}>
                    {item.icon}
                    <TextBold>{item.text}</TextBold>
                  </Box>
                )}
              />
            </Flex>
          </Condition>
        </OutsideClickHandler>
      </Flex>
    </Flex>
  );
};

export default Header;
